export const locationModel = {
   'name': {
      'title': "Name",
      'display': true
   }
};